import React, {useEffect, useState} from 'react';

import { ProductFormProvider } from '../../context/product-form-context';

import PDPImageZoomSlider from '../PDPImageZoomSlider';
import PDPForm from '../PDPForm/PDPForm';

const PDPImageForm = ({
	location, product, shortDescription, shopPay, addToCartIcons, setQuickShopOpen, useUrlParameter, elevarUserEventLoaded
}) => {
	const {
		variants,
		images,
	} = product;
	const hasVariants = !product.hasOnlyDefaultVariant;
	const productImages = images.map(image => image.image);

	if (!product.hasOnlyDefaultVariant) {
		productImages.splice(2, variants.length);
	}

	const [variantFormatRadios, setVariantFormatRadios] = useState(false);
	const [variantSizeFlavourButtons, setVariantSizeFlavourButtons] = useState(false);

	useEffect(() => {
		window.enableFormatRadios = () => {
			setVariantFormatRadios(true);
		};
		window.enableSizeFlavourButtons = () => {
			setVariantSizeFlavourButtons(true);
		};
	}, []);
	/* END GOOGLE EXPERIMENT SETUP */

	return (
		<ProductFormProvider
			product={product}
			location={location}
			useUrlParameter={useUrlParameter}
			preselect1stAvailableVariant
			useReplaceState
			renderingScheme={{
				0: variantFormatRadios ? 'radio' : 'button',
				1: variantSizeFlavourButtons ? 'combined' : 'select',
				2: 'default',
			}}
		>
			<div className={'pdp-image-slider__container'}>
				<PDPImageZoomSlider
					hasVariants={hasVariants}
					images={productImages}
				/>
			</div>
			<div className={'pdp-form__container'}>
				<PDPForm
					location={location}
					shortDescription={shortDescription}
					setQuickShopOpen={setQuickShopOpen}
					shopPay={shopPay}
					addToCartIcons={addToCartIcons}
					elevarUserEventLoaded={elevarUserEventLoaded}
				/>
			</div>
		</ProductFormProvider>
	);
};

export default PDPImageForm;
